import React, { useEffect, useState } from "react";
import ReactDom from "react-dom";

import styles from "./actionDetailsModal.module.css";
import Button from "../button/button";

// ponytail: preferência guardada no navegador (localStorage), não por usuário no servidor.
// Se um dia precisar seguir o usuário entre máquinas, vira campo em Users.
const SKIP_KEY = "actionQueue.skipDismissConfirm";

export const shouldSkipDismissConfirm = () => {
  try {
    return localStorage.getItem(SKIP_KEY) === "1";
  } catch (error) {
    return false;
  }
};

const rememberSkip = () => {
  try {
    localStorage.setItem(SKIP_KEY, "1");
  } catch (error) {
    // sem storage disponível: volta a perguntar na próxima
  }
};

const DismissConfirmModal = ({ item, onConfirm, onClose }) => {
  const [skipNext, setSkipNext] = useState(false);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  if (!item) {
    return null;
  }

  const handleConfirm = () => {
    if (skipNext) {
      rememberSkip();
    }
    onConfirm(item);
  };

  return ReactDom.createPortal(
    <div className={styles.modalBackdrop} onClick={onClose}>
      <div className={`${styles.modalContent} ${styles.confirm}`} onClick={(event) => event.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>Ignorar esta ação?</h3>
          <button type="button" className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>

        <p className={styles.confirmText}>
          "{item.title}" sai da fila e não volta, mesmo que a condição continue.
          Se o mesmo problema aparecer no mês seguinte, uma nova ação é criada.
        </p>

        <label className={styles.confirmCheck}>
          <input
            type="checkbox"
            checked={skipNext}
            onChange={(event) => setSkipNext(event.target.checked)}
          />
          Não perguntar novamente
        </label>

        <div className={styles.confirmActions}>
          <Button text="Cancelar" variation="primary" size="normal" onClick={onClose} />
          <Button text="Ignorar" variation="danger" size="normal" onClick={handleConfirm} />
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DismissConfirmModal;
